export default {
  name: 'TextAnalogyQuestion',
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    interactive: {
      type: Boolean,
      default: true
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    review: {
      type: Object,
      default: null
    }
  },
  emits: ['choose'],
  data() {
    return {
      selected: null
    };
  },
  computed: {
    instructionText() {
      return this.question.instructionText || '“____”处填入哪个词能构成最佳类比？请从四个选项中选出正确答案。';
    },
    stemParts() {
      const parts = String(this.question.stemText || '').split('____');
      return [parts[0] || '', parts.slice(1).join('____') || ''];
    },
    normalizedOptions() {
      if (Array.isArray(this.question.options)) return this.question.options;
      try {
        return JSON.parse(this.question.optionItemsJson || '[]');
      } catch (e) {
        return [];
      }
    }
  },
  watch: {
    question: {
      handler: 'init',
      deep: true
    },
    review: {
      handler: 'init',
      deep: true
    }
  },
  methods: {
    init() {
      this.selected = this.review?.answer || null;
    },
    choose(key) {
      this.selected = key;
      this.$emit('choose', key);
    },
    optionClass(key) {
      return {
        selected: !this.reviewMode && this.selected === key,
        correct: this.reviewMode && this.question.rightAnswer === key,
        wrong: this.reviewMode && this.review?.answer === key && this.question.rightAnswer !== key
      };
    }
  },
  mounted() {
    this.init();
  }
};